import React, { Component } from "react";
import { FormField } from "react-form";

import MuiCheckbox from "@material-ui/core/Checkbox";
import FormControlLabel from '@material-ui/core/FormControlLabel';
import FormHelperText from '@material-ui/core/FormHelperText';
import { withStyles } from "@material-ui/core";

const styles = {
    error: {
        color: "#be0000"
    }
};

class CheckboxWrapper extends Component {
    handleChange = event => {
        const { fieldApi, eventHandle, eventHandleProps1 } = this.props;
        const { setValue, getFieldName } = fieldApi;

        setValue(event.target.checked);

        if (eventHandle) eventHandle(event.target.checked, getFieldName(), this, eventHandleProps1);
    };

    render() {
        const { fieldApi, label, align, classes, color, children, ...rest } = this.props;

        const { getValue, getError, getWarning, setTouched } = fieldApi;

        const value = getValue() || false,
            error = getError(),
            warning = getWarning(),
            hasError = !!(error || warning);

        return (
            <div className={align}>
                <FormControlLabel
                    control={
                        <div>
                            <MuiCheckbox
                                color={color ? color : "primary"}
                                onChange={this.handleChange}
                                onBlur={() => setTouched()}
                                checked={value}
                                {...rest}
                            />
                        </div>
                    }
                    label={label}
                    classes={{
                        label: hasError ? classes.error : ""
                    }}
                />
                <FormHelperText style={{width:150,marginBottom:40,marginTop:-40}}>{children}</FormHelperText>
                {hasError && (
                    <FormHelperText className={align} error={true}>
                        {error}
                    </FormHelperText>
                )}
            </div>
        );
    }
}

const Checkbox = FormField(CheckboxWrapper);

export default withStyles(styles)(Checkbox);
